import { Col, Row, Badge } from "antd";
import { IoIosArrowRoundBack } from "react-icons/io";
import { useNavigate, useParams } from "react-router-dom";
import { extractDate } from "../../config/helpers";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Get } from "../../config/api/get";
import { ADMIN, SUBSCRIPTION } from "../../config/constants/api";

const UserDetails = () => {
  const [subscription, setSubscription] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();
  const [userDetails, setUserDetails] = useState(null);
  // const [active, setActive] = useState(false);
  const [loading, setLoading] = useState(true);
  const token = useSelector((state) => state.user.userToken);
  const getSubscription = async () => {
    Get(`${SUBSCRIPTION.getSubscription}${id}`, token)
      .then((response) => {
        if (response?.status) {
          setSubscription(response.data);
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  };
  useEffect(() => {
    getSubscription();
    // eslint-disable-next-line
  }, []);
  const getUserDetails = () => {
    setLoading(true);
    Get(`${ADMIN.getUser}${id}`, token)
      .then((response) => {
        setUserDetails(response?.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log("Error fetching user details", err);
        setLoading(false);
      });
  };
  useEffect(() => {
    getUserDetails();
    // eslint-disable-next-line
  }, []);

  // const banUser = (id, status, value) => {
  //   Put(`${ADMIN.toggleUser}${id}`, token, { status })
  //     .then((response) => {
  //       if (response.status) {
  //         swal("System Alert!", response?.message, "success");
  //         setActive(value);
  //       }
  //     })
  //     .catch((err) => {
  //       let message = err?.response?.data?.message;
  //       console.log(":::;", err);
  //       if (message) swal("Oops!", message, "error");
  //     });
  // };

  return (
    <Row justify="center">
      {!loading && (
        <Col md={23} xs={22}>
          <div
            className="bg-white rounded-lg sm:py-16 py-8 my-12"
            style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)" }}
          >
            <div className="flex justify-between mx-1 lg:mx-8 mb-4">
              <div className="flex justify-center items-center">
                <IoIosArrowRoundBack
                  onClick={() => navigate(-1)}
                  className="self-center cursor-pointer mr-1 w-[48px] h-[48px] max-sm:w-[24px] max-sm:h-[24px] text-black"
                />
                <h3 className="font-tavi lg:text-3xl text-2xl max-sm:text-lg font-normal text-black">
                  Membership Details
                </h3>
              </div>
              {/* <div className="flex justify-center items-center customSwitch1">
              <p
                className={`font-euclid text-sm max-sm:text-xs font-bold mr-2 ${
                  active ? "text-[#333333]" : "text-gray-400"
                }`}
              >
                Active
              </p>
              <Switch
                checkedChildren={
                  <FaCheck size={24} className="mt-1 text-white" />
                }
                unCheckedChildren={
                  <IoCloseSharp size={24} className="text-[#8D8D8D] ml-4" />
                }
                checked={active}
                // defaultChecked
                onChange={onChange}
              />
              <p
                className={`font-euclid text-sm max-sm:text-xs font-bold ml-2 ${
                  !active ? "text-[#f83131]" : "text-gray-400"
                }`}
              ></p>
              Ban User
            </div> */}
            </div>

            <Row justify="center">
              <Col xs={22} sm={18} md={18} xl={12}>
                {userDetails?.subscription && (
                  <Badge.Ribbon
                    text={userDetails?.subscription?.plan?.title}
                    className="profile-badge"
                    style={{
                      fontSize: "12px",
                      padding: "5px 10px",
                      fontWeight: "bold",
                      backgroundColor: "#d7a641",
                    }}
                  ></Badge.Ribbon>
                )}
                <div className="bg-[#EBEBEB] rounded-lg flex flex-col items-center justify-center sm:py-12 py-6">
                  <h3 className="font-tavi lg:text-3xl text-2xl max-sm:text-lg font-normal text-black">
                    {subscription?.plan?.title}
                  </h3>
                  {/* <Image
                  preview={false}
                  alt={"Failed to load image"}
                  src={UPLOADS_URL + userDetails?.image}
                  className=""
                  style={{
                    height: "180px",
                    width: "180px",
                    borderRadius: "100%",
                    objectFit: "cover",
                    objectPosition: "center",
                  }}
                /> */}

                  <div className="flex justify-center items-center my-4 p-3">
                    <div className="flex flex-col items-start lg:mr-32 mr-8">
                      <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                        Duration
                      </h5>
                      <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                        Paid Monthly
                      </p>
                      <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                        Amount Paid
                      </h5>
                      <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                        ${subscription?.plan?.dicountedAmount}
                        .00
                      </p>
                      <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                        Hours Consumed Till Now
                      </h5>
                      <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                        {subscription?.plan?.totalHours -
                          subscription?.remainingHours}{" "}
                        hours
                      </p>
                    </div>
                    <div className="flex flex-col items-start">
                      <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                        Date of Purchase
                      </h5>
                      <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                        {extractDate(subscription?.purchaseDate)}
                      </p>
                      <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                        Hours Included
                      </h5>
                      <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                        {subscription?.plan?.hours} hours
                      </p>
                      <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                        Each Booking Duration
                      </h5>
                      <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                        {subscription?.plan?.bookingDuration} hours (one
                        booking)
                      </p>
                    </div>
                  </div>
                  <div className="flex flex-col items-center justify-center">
                    {/* <button
                    className="uppercase bg-button py-4 px-6 xl:px-16 text-black rounded-lg font-bold text-sm max-md:text-[10px] max-md:py-2 max-md:px-4"
                    onClick={() =>
                      navigate("/reportManagement", {
                        state: { userId: userDetails?._id },
                      })
                    }
                  >
                    See Luxury Car Bookings
                  </button> */}
                    {/* <button
                    className="w-full uppercase bg-transparent border border-black py-4 px-6 xl:px-16 text-black rounded-lg font-bold text-sm max-md:text-[10px] max-md:py-2 max-md:px-4 mt-4"
                    onClick={() => navigate("/reservation")}
                  >
                    see rides history
                  </button> */}
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      )}
    </Row>
  );
};

export default UserDetails;
